import * as React from 'react';

export function DashronBrand({ id = '', className = '' }: { id?: string; className?: string }) {
	return (
		<div className={`flex flex-row items-center justify-center ${className}`}>
			<a id={`dashron-brand${id}`} className="z-20 pb-0 pl-0 dashron-brand is-size-2 neonText" href="/">
				Dashron
			</a>
			<svg
				viewBox="0 0 10 10"
				xmlns="http://www.w3.org/2000/svg"
				xmlnsXlink="http://www.w3.org/1999/xlink"
				className="w-[75px] h-[75px] absolute top-0 z-10 -ml-[9px]"
			>
				<defs>
					<linearGradient id="myGradient" gradientTransform="rotate(90)">
						<stop offset="5%" stopColor="#fcfe2f" />
						<stop offset="95%" stopColor="#e03168" />
					</linearGradient>
				</defs>

				<circle cx="5" cy="5" r="4" fill="url('#myGradient')" />
			</svg>
		</div>
	);
}